// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31sA9","footer":"styles_footer__3EmzC"};